//
// Result.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "../dataDefinition/DataDefinition";
import "./ResultType";
import "./ResultStatus";
import "./ResultReason";
import "./ResultDataLevel";
import "./ConsumerDataModelType";
import "./Presentation";
import "./ResultVariable";
import "./ResultColumn";
import "./DefinedSortItem";
import "../common/BIRDDate";
import "./BIRDData";
import "./StringTable";
import "./DataParameter";
import "./ResultMessage";
import "./MapDataFile";
import "../common/BIRDProperty";

var Result = createModule("BIRD::Result", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        date: 1,
        reason: 4,
        data: 1,
        columns: [1],
        type: 4,
        presentations: [1],
        diagnosticProperties: [1],
        tableDateModified: 7,
        sortRequiresReaggregation: 2,
        dataDefinition: 1,
        definedSortItems: [1],
        filterCompareString: 7,
        olapVariables: [1],
        supportsExportDetail: 2,
        consumerDataModel: 4,
        mapDataFiles: [1],
        variables: [1],
        sortLocale: 7,
        definedColumnSortItems: [1],
        resourceName: 7,
        label: 7,
        stringTable: 1,
        supportsCustomQuery: 2,
        messages: [1],
        dataLocale: 7,
        parameters: [1],
        dataLevel: 4,
        definedRowSortItems: [1],
        status: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Result;
